import '@fortawesome/fontawesome-free/css/all.min.css';
import { Navigate, Outlet, Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import axios from "axios";
import AccountClosureReport from './Banking/Bankingpages/AccountClosureReport';
import AccountClosureRequest from './Banking/Bankingpages/AccountClosureRequest';
import AccountMapping from './Banking/Bankingpages/AccountMapping';
import BankingReportsPage from './Banking/Bankingpages/BankingReport';
import FdMisReport from './Banking/Bankingpages/FdMisReport';
import DdInstallmentReport from './Banking/Bankingpages/DdInstallmentReport';
import DdCollectionReport from './Banking/Bankingpages/DdCollectionReport'
import RdDdReport from './Banking/Bankingpages/RdDdReport';
import SavingReport from './Banking/Bankingpages/SavingReport';
import TransactionReport from './Banking/Bankingpages/TransactionReport';
import AdminMessage from './components/AdminMessage';
import Calculator from './components/Calculator';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import EmployeeIdCard from './letters/EmployeeIdCard';
import ExperienceLetter from './letters/ExperienceLetter';
import OfferLetter from './letters/OfferLetter';
import AgreementLetter from './letters/AgreementLetter'
import JoiningLetter from './letters/JoiningLetter';
import PaySlip from './letters/PaySlip';
import PromotionLetter from './letters/PromotionLetter';
import CollectionReport from './loans/CollectionReport';
import EmiDueReport from './loans/EmiDueReport';
import LegalDocuments from './loans/LegalDocuments';
import LoanAgreementPage from './loans/LoanAgreementPage';
import LoanCardPage from './loans/LoanCardPage';
import LoanClosureReport from './loans/LoanClosureReport';
import LoanDisbursementPage from './loans/LoanDisbursement';
import LoanDisbursementReport from './loans/LoanDisbursementReport';
import LoanKycApproval from './loans/LoanKycApproval';
import LoanReport from './loans/LoanReport';
import NPAReport from './loans/NPAReport';
import OutDatedReport from './loans/OutDatedReport';
import PendingDisbursal from './loans/PendingDisbursal';
import ReportCards from './loans/Report';
import UpdateLoan from './loans/UpdateLoan';
import ViewEmiLoanData from './loans/ViewEmiLoanData';
import AgentCommission from './pages/AgentCommission';
import AssignDocument from './pages/AssignDocument';
import AttendanceCalculator from './pages/AttendanceCalculator';
import BranchMaster from './pages/BranchMaster';
import CalculateSalary from './pages/CalculateSalary';
import SalaryReport from './pages/SalaryReport';
import CommissionMaster from './pages/CommissionMaster';
import CompanyBankAccount from './pages/CompanyBankAccount';
import CompanyCapital from './pages/CompanyCapital';
import ContactUs from './pages/ContactUs';
import CreateEmployee from './pages/CreateEmployee';
import CustomerKyc from './pages/CustomerKyc';
import CustomerReport from './pages/CustomerReport';
import Dashboard from './pages/Dashboard';
import DisbursementReport from './pages/DisbursementReport';
import EmployeeKyc from './pages/EmployeeKyc';
import EmployeeLetter from './pages/EmployeeLetter';
import EmployeeReport from './pages/EmployeeReport';
import LeaveReport from './pages/leave_report';
import FeeMaster from './pages/FeeMaster';
import FundRequestApproval from './pages/FundApproval';
import EmiDueReportMember from './pages/groupLoanEmi';
import EmiDueReportGroup from './pages/groupLoanReport';
import GroupLoanStatus from './pages/groupLoanStatus';
import HolidayForm from './pages/HolidayForm';
import LoanScheme from './pages/LoanScheme';
import Login from './pages/Login';
import ManageCompanyDetails from './pages/ManageCompany';
import AgentCommissionMaster from './pages/AgentCommissionMaster';
import ManageLetters from './pages/ManageLetters';
import ManagePermission from './pages/ManagePermission';
import ProductLoan from './pages/ProductLoan';
import RoleMaster from './pages/RoleMaster';
import SalaryDisbursement from './pages/SalaryDisbursement';
import SalaryMaster from './pages/SalaryMaster';
import SavingScheme from './pages/SavingScheme';
import SearchCustomer from './pages/SearchCustomer';
import SmsMaster from './pages/SmsMaster';
import SuperAdminProfile from './pages/SuperAdminProfile';
import UpdatePassword from './pages/UpdatePassword';
import WalletMaster from './pages/WalletMaster';

import SavingsScheme from './pages/SavingScheme';
import CurrentScheme from './pages/CurrentScheme';
import FDScheme from './pages/FDScheme';
import RDScheme from './pages/RDScheme';

// Landing page components
import Contactlanding from './landing/Contactlanding';
import ContactSection from './landing/ContactSection';
import FeaturesSection from './landing/FeaturesSection';
import Footerlanding from './landing/Footerlanding';
import Hero from './landing/Hero';
import Navbarlanding from './landing/Navbarlanding';
import NewsTicker from './landing/NewsTicker';
import PersonalLoanlanding from './landing/PersonalLoanlanding';
import SavingAccountlanding from './landing/SavingAccountlanding';
import ServiceNavlanding from './landing/ServiceNavlanding';
import ServicesSection from './landing/ServicesSection';
import Together from './landing/Together';
import KycLoanDetail from './pages/KycLoanDetail';
import AboutUslanding from './landing/AboutUslanding';


import Termslanding from "./pages/TermsAndConditions";
import FaviconUpdater from "./hooks/fevicon_addeded";

import Privacylanding from './landing/Privacylanding';
import Faq from './pages/Faq';
import Support from './pages/Support';
import TeamsPage from "./landing/TeamsPage";


// Demo

import Dashboards from './Demo/Dashboards';
import DemoLogin from './Demo/DemoLogin';
import Dashboarddd from './Banking/Bankingpages/Dashboarddd'






import { useCompanyBranding } from "./hooks/useCompanyBranding";
import { setFavicon, setTitle } from "./hooks/setmeta";
import GroupLoanScheme from './pages/ManageMaster/GroupLoanScheme';
import AreaSurveyReport from './loans/AreaSurveyReport';
import CenterReport from './loans/CenterReport';
import CgtReport from './loans/CgtReport';
import GrtReport from './loans/GrtReport';
import AddCgt from './GroupLoanReport/AddCgt';
import CgtTopic from './GroupLoanReport/CgtTopic';
import GroupLoanReport from './GroupLoanReport/GroupLoanReport';
import LoanReportTest from './GroupLoanReport/LoanReportTest';
import AppliedLoanTest from './GroupLoanReport/AppliedLoanTest';
import PendingDisbursalTest from './GroupLoanReport/PendingDisbursalTest';
import DisbursedReportTest from './GroupLoanReport/DisbursedReportTest';
import EmiDueReportTest from './GroupLoanReport/EmiDueReportTest';
import DemandSheet from './GroupLoanReport/DemandSheet';
import NpaReport from './GroupLoanReport/NpaReport';
import LoanCloserReport from './GroupLoanReport/LoanCloserReport';
import CDSReport from './GroupLoanReport/CDSReport';
import LoanClosureVerify from './loans/LoanClosureVerify';
import CollectionReportTest from './GroupLoanReport/CollectionReportTest'
import GroupMember from './pages/GroupMember';
import ViewAreaSurveyReport from './pages/ViewReports/ViewAreaSurveyReport';
import GroupList from './Accountant/GroupList';
import LedgerList from './Accountant/LedgerList';
import BranchLedgerList from './Accountant/BranchLedgerList';
import FundTransfer from './Accountant/FundTransfer';
import Overview from './Accountant/Overview';
import ProfitLoss from './Accountant/ProfitLoss';

import DayBook from './Accountant/Voucher/DayBook';
import CashBook from './Accountant/Voucher/CashBook'
import VoucherEntries from './Accountant/Voucher/VoucherEntries'
import Payment from './Accountant/Voucher/Payment'
import TrialBalance from './Accountant/Voucher/TrialBalance'
import FyTrialBalance from './Accountant/Voucher/FyTrialBalance'
import FyOpeningBalance from './Accountant/Voucher/FyOpeningBalance'
import LoanCard from './GroupLoanReport/LoanCard';
import ViewLoanEmi from './GroupLoanReport/ViewLoanEmi';
import SingleLoanEmiPayment from './GroupLoanReport/SingleLoanEmiPayment';
import Counter from './Accountant/Voucher/Counter';
import Journal from './Accountant/Voucher/Journal';
import Receipt from './Accountant/Voucher/Receipt'
import PaymentReceipt from './Accountant/Voucher/PaymentReceipt';
import DemoDashboard from './pages/DemoDashboard';
import FundApprovalReport from './pages/FundApprovalReport';
import AttendanceSummary from './pages/AttendanceSummary';

// quick access imports
import QuickLoan from './Quick Access/Quick Loan/QuickLoan'
import QuickBankAccount from './Quick Access/Quick Bank Account/QuickBankAccount'
import CareerRequest from './Quick Access/Career Rquest/CareerRequest';
import ViewQuickLoanReport from './Quick Access/Quick Loan/ViewQuickLoanReport';
import ViewBankAccountReport from './Quick Access/Quick Bank Account/ViewBankAccountReport';
import useDevToolsLogout from './hooks/useDevToolsLogout';
import GoldLoanScheme from './GoldLoan/GoldLoanScheme';
import GoldLoanReport from './GoldLoan/GoldLoanReport';
import GoldLoanEmiDueReport from './GoldLoan/GoldLoanEmiDueReport';
import GoldLoanCollectionReport from './GoldLoan/GoldLoanCollectionReport';
import GoldRate from './GoldLoan/GoldRate';
import  Testing from './Testing/Testing';
import GoldLoanViewEmi from './GoldLoan/GoldLoanViewEmi';
import GoldLoanCard from './GoldLoan/GoldLoanCard';
import VehicleLoanScheme from './VehicleLoan/VehicleLoanScheme';
import SeriesMaster from './pages/ManageMaster/SeriesMaster';
import Wallet from './pages/ManageMaster/Wallet';
import CustomerCreate from './pages/CustomerCreate';
import LoanPreClosure from './loans/LoanPreClosure';
import LoanSettlement from './loans/LoanSettlement';
import AppliedGoldLoan from './GoldLoan/AppliedGoldLoan';
import GoldLoanPendingDisbursal from './GoldLoan/GoldLoanPendingDisbursal';
import DisbursedGoldLoan from './GoldLoan/DisbursedGoldLoan';
import Preloader from './landing/Preloader';
import { AnimatePresence,motion } from 'framer-motion';
import ProductScheme from './Product Master/ProductScheme';
import VenderMaster from './Product Master/VenderMaster';
import ProductMaster from './Product Master/ProductDetails';
import LoanSettlementApprove from './loans/LoanSettlementApprove';
import Category from './Product Master/Category';
import Brand from './Product Master/Brand';
import Model from './Product Master/Model';
import Varient from './Product Master/Varient';
import ProductDetails from './Product Master/ProductDetails';
import ProductLoanReport from './Product Master/ProductLoanReport';
import ProductEmiDueReport from './Product Master/ProductEmiDueReport';
import ProductCollectionReport from './Product Master/ProductCollectionReport';
import MisPay from './Banking/Bankingpages/MisPay';
import ForceCloser from './GroupLoanReport/ForceCloser';
import AssignCgtTopic from './GroupLoanReport/AssignCgtTopic';
import AddGrt from './GroupLoanReport/AddGrt';
import BranchWallet from './Accountant/BranchWallet';
import LegalDocumentsPage from './landing/LegalDocumentsPage';

// Private Route Wrapper (checks only for user login)
const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('user');
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Layout (includes sidebar and header when logged in)
const Layout = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const isAuthenticated = !!localStorage.getItem('user');
  const user=localStorage.getItem("user")

  useDevToolsLogout(!!user); // 🔥 Yaha lagana hai

  return (
    <div className="main-wrapper">
      {isAuthenticated && !isLoginPage && <Sidebar />}
      <div className="page-wrapper">
        {isAuthenticated && !isLoginPage && <Header />}
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

// Landing page wrapper (full screen, no sidebar/header)
// const LandingPage = () => {
//   const [isLoading, setIsLoading] = useState(true);

//   // useEffect(() => {
//   //   setTimeout(() => {
//   //     setLoading(false);
//   //   }, 4000); 
//   // }, []);
//   return (
//     <div
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         overflowX: "hidden",
//       }}
//     >
//       <Navbarlanding />
//       {/* <Hero /> */}
//       <div>
//       <AnimatePresence>
//         {isLoading ? (
//           <Preloader key="loader" onComplete={() => setIsLoading(false)} />
//         ) : (
//           <Hero key="hero" /> // Aapka main website content
//         )}
//       </AnimatePresence>
//     </div>
//       <NewsTicker />
//       <FeaturesSection />
//       <ServicesSection />
//       <Together />
//       <ContactSection />
//       <Footerlanding />
//       <Outlet />
//     </div>
//   );
// };


const LandingPage = () => {
  const [isLoading, setIsLoading] = useState(() => {
    return !sessionStorage.getItem("hasLoadedBefore");
  });

  const handleComplete = () => {
    sessionStorage.setItem("hasLoadedBefore", "true");
    setIsLoading(false);
  };

  return (
    <div style={{ width: "100%", minHeight: "100vh", overflowX: "hidden" }}>
      <AnimatePresence mode="wait">
        {isLoading ? (
          <Preloader key="loader" onComplete={handleComplete} />
        ) : (
          <motion.div
            key="main-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <Navbarlanding />
            <Hero />
            <NewsTicker />
            <FeaturesSection />
            <ServicesSection />
            <Together />
            <ContactSection />
            <Footerlanding />
          </motion.div>
        )}
      </AnimatePresence>
      <Outlet />
    </div>
  );
};

export default function App() {

  const { company, fetchError, loading } = useCompanyBranding();



  // if (loading) {
  //   return <div>Loading...</div>;
  // }



  return (
    <Router>
      <FaviconUpdater />
      <Routes>

        {/* Base landing route */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/apply-savings" element={<SavingAccountlanding />} />
        <Route path="/personal-loan" element={<PersonalLoanlanding />} />
        <Route path="/service" element={<ServiceNavlanding />} />
        {/* <Route path="/team-members" element={<TeamMembersLanding />} /> */}
        <Route path="/legal-documents" element={<LegalDocumentsPage />} /> 
        <Route path="/contact" element={<Contactlanding />} />
        <Route path="/about" element={<AboutUslanding />} />
        <Route path="/terms" element={<Termslanding />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/support" element={<Support/>} />
        <Route path="/privacy" element={<Privacylanding />} />
        <Route path="/teams" element={<TeamsPage />} />



        {/* Auth pages with layout */}
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path='/DemoDashboard' element={<DemoDashboard />} />

                <Route path="/ManageCompany" element={<PrivateRoute><ManageCompanyDetails /></PrivateRoute>} />
                <Route path="/CommissionMaster" element={<PrivateRoute><CommissionMaster /></PrivateRoute>} />
                <Route path="/AgentCommissionMaster" element={<PrivateRoute><AgentCommissionMaster /></PrivateRoute>} />
                <Route path="/LoanScheme" element={<PrivateRoute><LoanScheme /></PrivateRoute>} />
                <Route path="/AssignDocument" element={<PrivateRoute><AssignDocument /></PrivateRoute>} />
                <Route path="/RoleMaster" element={<PrivateRoute><RoleMaster /></PrivateRoute>} />
                <Route path="/SavingScheme" element={<PrivateRoute><SavingScheme /></PrivateRoute>} />
                <Route path="/SmsMaster" element={<PrivateRoute><SmsMaster /></PrivateRoute>} />
                <Route path="/FeeMaster" element={<PrivateRoute><FeeMaster /></PrivateRoute>} />
                <Route path="/BranchMaster" element={<PrivateRoute><BranchMaster /></PrivateRoute>} />
                <Route path="/ManageMaster/SeriesMaster" element={<PrivateRoute><SeriesMaster /></PrivateRoute>} />
                <Route path="/ManageMaster/Wallet" element={<PrivateRoute><Wallet /></PrivateRoute>} />
                <Route path="/HolidayForm" element={<PrivateRoute><HolidayForm /></PrivateRoute>} />
                <Route path="/ManageLetters" element={<PrivateRoute><ManageLetters /></PrivateRoute>} />
                <Route path="/ManagePermission" element={<PrivateRoute><ManagePermission /></PrivateRoute>} />
                <Route path="/ProductLoan" element={<PrivateRoute><ProductLoan /></PrivateRoute>} />
                <Route path="/ContactUs" element={<PrivateRoute><ContactUs /></PrivateRoute>} />
                <Route path="/SearchCustomer" element={<PrivateRoute><SearchCustomer /></PrivateRoute>} />
                <Route path="/CustomerCreate" element={<PrivateRoute><CustomerCreate /></PrivateRoute>} />
                <Route path="/CustomerKyc" element={<PrivateRoute><CustomerKyc /></PrivateRoute>} />
                <Route path="/CustomerReport" element={<PrivateRoute><CustomerReport /></PrivateRoute>} />
                <Route path="/CreateEmployee" element={<PrivateRoute><CreateEmployee /></PrivateRoute>} />
                <Route path="/employee/edit/:id" element={<PrivateRoute><CreateEmployee /></PrivateRoute>} />
                <Route path="/EmployeeKyc" element={<PrivateRoute><EmployeeKyc /></PrivateRoute>} />
                <Route path="/EmployeeReport" element={<PrivateRoute><EmployeeReport /></PrivateRoute>} />
                <Route path="/LeaveReport" element={<PrivateRoute><LeaveReport /></PrivateRoute>} />
                <Route path="/UpdatePassword" element={<PrivateRoute><UpdatePassword /></PrivateRoute>} />
                <Route path="/EmployeeLetter" element={<PrivateRoute><EmployeeLetter /></PrivateRoute>} />
                <Route path="/SalaryMaster" element={<PrivateRoute><SalaryMaster /></PrivateRoute>} />
                <Route path="/AttendanceCalculator" element={<PrivateRoute><AttendanceCalculator /></PrivateRoute>} />
                <Route path="/AttendanceSummary" element={<PrivateRoute><AttendanceSummary /></PrivateRoute>} />
                <Route path="/WalletMaster" element={<PrivateRoute><WalletMaster /></PrivateRoute>} />
                <Route path="/FundApproval" element={<PrivateRoute><FundRequestApproval /></PrivateRoute>} />
                <Route path="/FundApprovalReport" element={<PrivateRoute><FundApprovalReport /></PrivateRoute>} />
                <Route path="/SalaryDisbursement" element={<PrivateRoute><SalaryDisbursement /></PrivateRoute>} />
                <Route path="/DisbursementReport" element={<PrivateRoute><DisbursementReport /></PrivateRoute>} />
                <Route path="/CalculateSalary" element={<PrivateRoute><CalculateSalary /></PrivateRoute>} />
                <Route path="/SalaryReport" element={<PrivateRoute><SalaryReport /></PrivateRoute>} />
                <Route path="/AgentCommission" element={<PrivateRoute><AgentCommission /></PrivateRoute>} />
                <Route path="/SuperAdminProfile" element={<PrivateRoute><SuperAdminProfile /></PrivateRoute>} />
                <Route path="/CompanyBankAccount" element={<PrivateRoute><CompanyBankAccount /></PrivateRoute>} />
                <Route path="/CompanyCapital" element={<PrivateRoute><CompanyCapital /></PrivateRoute>} />
                <Route path="/Report" element={<PrivateRoute><ReportCards /></PrivateRoute>} />
                <Route path="/LoanReport" element={<PrivateRoute><LoanReport /></PrivateRoute>} />
                <Route path="/LoanDisbursementReport" element={<PrivateRoute><LoanDisbursementReport /></PrivateRoute>} />
                <Route path="/EmiDueReport" element={<PrivateRoute><EmiDueReport /></PrivateRoute>} />
                <Route path="/Loan/KycLoanDetail" element={<PrivateRoute><KycLoanDetail /></PrivateRoute>} />
                <Route path="/CollectionReport" element={<PrivateRoute><CollectionReport /></PrivateRoute>} />
                <Route path="/NPAReport" element={<PrivateRoute><NPAReport /></PrivateRoute>} />
                <Route path="/OutDatedReport" element={<PrivateRoute><OutDatedReport /></PrivateRoute>} />
                <Route path="/LoanClosureReport" element={<PrivateRoute><LoanClosureReport /></PrivateRoute>} />
                <Route path="/LoanClosureVerify/:id" element={<PrivateRoute><LoanClosureVerify /></PrivateRoute>} />
                <Route path="/PendingDisbursal" element={<PrivateRoute><PendingDisbursal /></PrivateRoute>} />
                <Route path="/JoiningLetter" element={<PrivateRoute><JoiningLetter /></PrivateRoute>} />
                <Route path="/EmployeeIdCard" element={<PrivateRoute><EmployeeIdCard /></PrivateRoute>} />
                <Route path="/PromotionLetter" element={<PrivateRoute><PromotionLetter /></PrivateRoute>} />
                <Route path="/ExperienceLetter" element={<PrivateRoute><ExperienceLetter /></PrivateRoute>} />
                <Route path="/OfferLetter" element={<PrivateRoute><OfferLetter /></PrivateRoute>} />
                <Route path="/AgreementLetter" element={<PrivateRoute><AgreementLetter /></PrivateRoute>} />
                <Route path="/PaySlip" element={<PrivateRoute><PaySlip /></PrivateRoute>} />
                <Route path="/BankingReports" element={<PrivateRoute><BankingReportsPage /></PrivateRoute>} />
                <Route path="/AccountMapping" element={<PrivateRoute><AccountMapping /></PrivateRoute>} />
                <Route path="/RdDdReport" element={<PrivateRoute><RdDdReport /></PrivateRoute>} />
                <Route path="/FdMisReport" element={<PrivateRoute><FdMisReport /></PrivateRoute>} />
                <Route path="/Banking/MisPay/:accId" element={<PrivateRoute><MisPay/></PrivateRoute>} />
                <Route path="/SavingReport" element={<PrivateRoute><SavingReport /></PrivateRoute>} />
                <Route path="/DdCollectionReport" element={<PrivateRoute><DdCollectionReport /></PrivateRoute>} />
                <Route path="/DdInstallmentReport" element={<PrivateRoute><DdInstallmentReport /></PrivateRoute>} />
                <Route path="/TransactionReport" element={<PrivateRoute><TransactionReport /></PrivateRoute>} />
                <Route path="/AccountClosureReport" element={<PrivateRoute><AccountClosureReport /></PrivateRoute>} />
                <Route path="/AccountClosureRequest" element={<PrivateRoute><AccountClosureRequest /></PrivateRoute>} />
                <Route path="/AdminMessage" element={<PrivateRoute><AdminMessage /></PrivateRoute>} />
                <Route path="/Calculator" element={<PrivateRoute><Calculator /></PrivateRoute>} />
                <Route path="/LoanKycApproval/:loanId" element={<PrivateRoute><LoanKycApproval /></PrivateRoute>} />
                <Route path="/UpdateLoan/:id" element={<UpdateLoan />} />
                <Route path="/LoanDisbursement/:loanId" element={<PrivateRoute><LoanDisbursementPage /></PrivateRoute>} />
                <Route path="/ViewEmiLoanData/:loanId" element={<PrivateRoute><ViewEmiLoanData /></PrivateRoute>} />
                <Route path="/groupLoanReport" element={<PrivateRoute><EmiDueReportGroup /></PrivateRoute>} />
                <Route path="/EmiDueReportMember" element={<PrivateRoute><EmiDueReportMember /></PrivateRoute>} />
                <Route path="/GroupLoanStatus" element={<PrivateRoute><GroupLoanStatus /></PrivateRoute>} />
                <Route path="/LoanCardPage/:loanId" element={<PrivateRoute><LoanCardPage /></PrivateRoute>} />
                <Route path="/LegalDocuments" element={<PrivateRoute><LegalDocuments /></PrivateRoute>} />
                <Route path="/LoanAgreementPage/:loanId" element={<PrivateRoute><LoanAgreementPage /></PrivateRoute>} />


                <Route path="/SavingsScheme" element={<PrivateRoute><SavingsScheme /></PrivateRoute>} />
                <Route path="/CurrentScheme" element={<PrivateRoute><CurrentScheme /></PrivateRoute>} />
                <Route path="/FDScheme" element={<PrivateRoute><FDScheme /></PrivateRoute>} />
                <Route path="/RDScheme" element={<PrivateRoute><RDScheme /></PrivateRoute>} />
                <Route path='/GroupLoanScheme' element={<GroupLoanScheme />} />
                <Route path='/AreaSurveyReport' element={<AreaSurveyReport />} />
                <Route path='/CenterReport' element={<CenterReport />} />
                <Route path='/CgtReport' element={<CgtReport />} />
                <Route path='/AddCgt' element={<PrivateRoute><AddCgt /></PrivateRoute>} />
                <Route path='/GroupLoan/AddGrt' element={<PrivateRoute><AddGrt /></PrivateRoute>} />
                <Route path='/CgtTopic' element={<PrivateRoute><CgtTopic /></PrivateRoute>} />
                <Route path='/GroupLoan/AssignCgtTopic' element={<PrivateRoute><AssignCgtTopic /></PrivateRoute>} />
                <Route path='/GrtReport' element={<GrtReport />} />


                <Route path='/GroupLoanReportTest' element={<GroupLoanReport />} />
                <Route path='/LoanReportTest' element={<LoanReportTest />} />
                <Route path='GroupLoan/ForceCloser' element={<ForceCloser />} />
                <Route path='/AppliedLoanTest' element={<AppliedLoanTest />} />
                <Route path='/PendingDisbursalTest' element={<PendingDisbursalTest />} />
                <Route path='/DisbursedReportTest' element={<DisbursedReportTest />} />
                <Route path='/EmiDueReportTest' element={<EmiDueReportTest />} />
                <Route path='/CDSReport' element={<CDSReport />} />
                <Route path='/DemandSheet' element={<DemandSheet/>} />
                <Route path='/CollectionReportTest' element={<CollectionReportTest />} />
                <Route path='/NpaReportTest' element={<NpaReport />} />
                <Route path='/LoanPreClosure' element={<LoanPreClosure />} />
                <Route path='/LoanSettlementApprove' element={<LoanSettlementApprove />} />
                <Route path='/LoanSettlement' element={<LoanSettlement />} />
                <Route path='/LoanCloserReport' element={<LoanCloserReport />} />
                <Route path='/GroupLoanReport/LoanCard' element={<LoanCard />} />
                <Route path='/GroupLoanReport/ViewLoanEmi' element={<ViewLoanEmi />} />
                <Route path="/GroupLoanReport/ViewLoanEmi/:loanId" element={<PrivateRoute><ViewLoanEmi /></PrivateRoute>} />
                <Route path="/SingleLoanEmiPayment" element={<PrivateRoute><SingleLoanEmiPayment /></PrivateRoute>} />
                <Route path='/GroupMember' element={<GroupMember />} />

                {/* Gold Loan */}
                <Route path="/GoldLoan/GoldLoanScheme" element={<PrivateRoute><GoldLoanScheme/></PrivateRoute>} />
                <Route path="/GoldLoan/GoldRate" element={<PrivateRoute><GoldRate/></PrivateRoute>} />
                <Route path="/GoldLoan/GoldLoanReport" element={<PrivateRoute><GoldLoanReport/></PrivateRoute>} />
                <Route path="/GoldLoan/AppliedGoldLoan" element={<PrivateRoute><AppliedGoldLoan/></PrivateRoute>} />
                <Route path="/GoldLoan/GoldLoanPendingDisbursal" element={<PrivateRoute><GoldLoanPendingDisbursal/></PrivateRoute>} />
                <Route path="/GoldLoan/DisbursedGoldLoan" element={<PrivateRoute><DisbursedGoldLoan/></PrivateRoute>} />
                <Route path="/GoldLoan/GoldLoanEmiDueReport" element={<PrivateRoute><GoldLoanEmiDueReport/></PrivateRoute>} />
                <Route path="/GoldLoan/GoldLoanCollectionReport" element={<PrivateRoute><GoldLoanCollectionReport/></PrivateRoute>} />
                <Route path="/GoldLoanViewEmi/:loanId" element={<PrivateRoute><GoldLoanViewEmi /></PrivateRoute>} />
                <Route path="/GoldLoanCard/:loanId" element={<PrivateRoute><GoldLoanCard /></PrivateRoute>} />
                <Route path="/VehicleLoan/VehicleLoanScheme" element={<PrivateRoute><VehicleLoanScheme/></PrivateRoute>} />

                {/* Product Master  */}
                <Route path="/ProductMaster/ProductScheme" element={<PrivateRoute><ProductScheme/></PrivateRoute>} />
                <Route path="/ProductMaster/VenderMaster" element={<PrivateRoute><VenderMaster/></PrivateRoute>} />
                <Route path="/ProductDetails" element={<PrivateRoute><ProductDetails/></PrivateRoute>} />
                <Route path="/ProductMaster/ProductLoanReport" element={<PrivateRoute><ProductLoanReport/></PrivateRoute>} />
                <Route path="/ProductMaster/Category" element={<PrivateRoute><Category/></PrivateRoute>} />
                <Route path="/ProductMaster/Brand" element={<PrivateRoute><Brand/></PrivateRoute>} />
                <Route path="/ProductMaster/Model" element={<PrivateRoute><Model/></PrivateRoute>} />
                <Route path="/ProductMaster/Varient" element={<PrivateRoute><Varient/></PrivateRoute>} />
                <Route path="/ProductMaster/ProductEmiDueReport" element={<PrivateRoute><ProductEmiDueReport/></PrivateRoute>} />
                <Route path="/ProductMaster/ProductCollectionReport" element={<PrivateRoute><ProductCollectionReport/></PrivateRoute>} />



                {/* Vehicle Loan  */}


                {/* Accountant */}
                <Route path='/Accountant/BranchWallet' element={<BranchWallet />} />
                <Route path='/Accountant/GroupList' element={<GroupList />} />
                <Route path='/Accountant/LedgerList' element={<LedgerList />} />
                <Route path='/Accountant/BranchLedgerList' element={<BranchLedgerList />} />
                <Route path='/Accountant/FundTransfer' element={<FundTransfer />} />
                <Route path='/Accountant/Overview' element={<Overview />} />
                <Route path='/Accountant/ProfitLoss' element={<ProfitLoss />} />
                {/* -------Voucher----- */}
                <Route path='/Accountant/Voucher/DayBook' element={<DayBook />} />
                <Route path='/Accountant/Voucher/CashBook' element={<CashBook />} />
                <Route path='/Accountant/Voucher/VoucherEntries' element={<VoucherEntries />} />
                <Route path='/Accountant/Voucher/Payment' element={<Payment />} />
                <Route path='/Accountant/Voucher/Counter' element={<Counter />} />
                <Route path='/Accountant/Voucher/Journal' element={<Journal />} />
                <Route path='/Accountant/Voucher/Receipt' element={<Receipt />} />
                <Route path='/Accountant/Voucher/PaymentReceipt' element={<PaymentReceipt />} />
                <Route path='/Accountant/Voucher/TrialBalance' element={<TrialBalance />} />
                <Route path='/Accountant/Voucher/FyTrialBalance' element={<FyTrialBalance />} />
                <Route path='/Accountant/Voucher/FyOpeningBalance' element={<FyOpeningBalance />} />

                {/* Quick Access Routes */}
                <Route path='/quick-loan' element={<QuickLoan />} />
                <Route path='/viewquickloanreport' element={<ViewQuickLoanReport />} />
                <Route path='/quick-bank-account' element={<QuickBankAccount />} />
                <Route path='/viewbankaccountreport' element={<ViewBankAccountReport />} />
                <Route path='/CareerRequest' element={<CareerRequest />} />

                {/* View full reports */}
                <Route path='/viewAreaSurveyReport' element={<ViewAreaSurveyReport />} />


                <Route path="/Dashboards" element={<PrivateRoute><Dashboards /></PrivateRoute>} />
                <Route path="/Dashboarddd" element={<PrivateRoute><Dashboarddd /></PrivateRoute>} />
                <Route path="/DemoLogin" element={<PrivateRoute><DemoLogin /></PrivateRoute>} />
                <Route path="/testing" element={<PrivateRoute><Testing /></PrivateRoute>} />



              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}
